__turbopack_context__.v({
  "onSaleFilterTrigger": "styles-module__WGCsQW__onSaleFilterTrigger",
});
